import { useState } from "react"
import { toast } from 'react-hot-toast';
import Loader from "../../Components/Common/Loader";
import SystemModal from "../../Components/Common/SystemModal";
import ajaxStudent from "../../util/remote/ajaxStudent";


const EditContactName=(props)=>{

    const [loading, setLoading] = useState(false)
    const [contactName, setContactName] = useState(props.contactName);

    const handleUpdate = async(e) =>{
        e.preventDefault()
        if(contactName.length>0){
            setLoading(true)
            const server_response = await ajaxStudent.editContactName(props.linkID, contactName);
            
            setLoading(false);
            if(server_response.status==="OK"){
                toast.success(server_response.message);
                props.g();
            }
            else{
                toast.error(server_response.message); 
            }
        }
        else{
            toast.error("Please enter the name of the contact!")
        }  
    }
    

    const RenderFooter=(controls)=>{

        if(loading){
            return <Loader/>
        }else{

            return <> 
                    <button className="btn-fill-md text-light bg-martini shadow-martini" type="button" onClick={controls.close}>Close</button>
                    <button 
                        type="button" 
                        className={`btn-fill-md text-light bg-dodger-blue`} 
                        onClick={handleUpdate}>Save Changes<i class="fas fa-check mg-l-15"></i></button>
                    </>
        }
    }

    return(
        <SystemModal
            title="Update Contact Name"
            id="model-update-contact_name"
            size="md"
            footer={RenderFooter}
        >

            <div className="mb-4 form-group border-1">
                <label htmlFor="">Contact Name</label>
                <input onChange={(e)=>setContactName(e.target.value)} value={contactName} type="text" className="form-control"/>
            </div>
           
       
        </SystemModal>
    )
}

export default EditContactName
